export default {
  providerResponse: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};
